<div class="terms-dialog">
    <h2 class="title">Termos de aceite</h2>
    <hr class="line">
    <div class="dialog-body">
        <mat-checkbox *ngFor="let term of allTerms" (change)="actionCheckBox($event, term)">{{term?.description}}</mat-checkbox>
    </div>
    <span class="warn" *ngIf="disabled">*Não é possivel realizar a emissão da apólice sem aceitar todos os termos.*</span>
    <div class="action">
        <button
        mat-raised-button 
        class="button__back button"
        type="button"
        (click)="close()"
        >
          VOLTAR
        </button>
        <button
          mat-raised-button
          id="botao-emitir-apolice"
          type="button"
          class="button__emit button"
          [disabled]="disabled"
          (click)="onEmit()"
        >
          EMITIR APÓLICE
        </button>
      </div>
</div>
